// extracted by mini-css-extract-plugin
export default {"gaAlertNotification":"alertNotification_gaAlertNotification__ETJpJ"};